export default __webpack_public_path__ + "static/media/red-full1.abecf8cb.png";